import type { RouteObject } from "react-router-dom";

export const supportRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Support" },
    async lazy() {
      const { Page } = await import("../app/page");
      return {
        element: (
          <Page
            hidePadding={(url) =>
              url.endsWith("/support") || url.endsWith("/support/")
            }
          />
        ),
      };
    },
    children: [
      {
        index: true,
        handle: { breadcrumb: "Conversation analytics" },
        async lazy() {
          const { ConversationAnalytics } =
            await import("./conversation-analytics/conversation-analytics");
          return { Component: ConversationAnalytics };
        },
      },
      {
        path: "conversation-analytics",
        handle: { breadcrumb: "Conversation analytics" },
        async lazy() {
          const { ConversationAnalytics } =
            await import("./conversation-analytics/conversation-analytics");
          return { Component: ConversationAnalytics };
        },
      },
      {
        path: "backfills",
        handle: { breadcrumb: "Backfills" },
        async lazy() {
          const { BackfillsPage } = await import("./backfills/backfills-page");
          return { Component: BackfillsPage };
        },
      },
      {
        path: "conversation-expenses",
        handle: { breadcrumb: "Conversation expenses" },
        async lazy() {
          const { ConversationExpensesPage } =
            await import("./conversation-expenses/conversation-expenses-page");
          return { Component: ConversationExpensesPage };
        },
      },
      {
        path: "partnerships",
        handle: { breadcrumb: "Partnerships" },
        async lazy() {
          const { SupportPartnershipsPage } =
            await import("./partnerships/partnerships-page");
          return { Component: SupportPartnershipsPage };
        },
      },
      {
        path: "migration-status",
        handle: { breadcrumb: "Support V2 migration status" },
        async lazy() {
          const { SupportV2MigrationStatusPage } =
            await import("./support-v2-migration-status/support-v2-migration-status-page");
          return { Component: SupportV2MigrationStatusPage };
        },
      },
    ],
  },
];
